<template>
  <div class="back-top" @click="backClick">
    <img src="~assets/img/music/play.svg" alt="">
  </div>
</template>

<script>
export default {
  name: "BackTop",
  data() {
    return {
      pic: "~assets/img/music/play.svg",
      paly: false
    }
  },
  methods: {
    backClick() {
      // if (this.play) {
      //   this.pic = "~assets/img/music/pause.svg";
      //   this.paly = !this.paly;
      // } else {
      //   this.pic = "~assets/img/music/play.svg";
      //   this.paly = !this.paly;
      // }
      this.$emit('backClick');
    }
  }
}
</script>

<style scoped>
.back-top {
  position: fixed;
  right: 10px;
  bottom: 50px;
}

.back-top img {
  width: 43px;
  height: 43px;
}
</style>
